export function isString(value) {
    return typeof value === 'string';
}
export const MOBILE_BREAK_POINT = 768; // Default mobile breakpoint
export const AllowedPlacements = ['bottom-start', 'top-end', 'bottom-end', 'top-start'];
